export enum UserRole {
  USER = 'USER',
  REDACTOR = 'REDACTOR',
  ADMIN = 'ADMIN'
}

export interface User {
  readonly id: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
  readonly role: UserRole;
  readonly confirmed: boolean;
  readonly disabled: boolean;
}

